import Vue from 'vue';
import axios from 'axios';
import {Message} from 'element-ui';

var localIp = 'http://10.100.70.231:8080',
    devIp = 'https://cydd.szincrease.com',
    prodIp = 'https://www.onecharging.com';

let HOST = process.env.HOST;

let Ip;

if (HOST === 'dev') {// 测试环境
    Ip = devIp;
} else {
    Ip = devIp;
}

const http = axios.create({
    baseURL: Ip,
    timeout: 1000 * 30,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json; charset=utf-8'
    }
});

http.ip = Ip;
http.incCharge = '/inc-charge';

/**
 * [httpRequest 封装请求的函数]
 * @param  {[type]} httpForm   [description]
 * @param  {[type]} httpServer [description]
 * @param  {[type]} _callback  [description]
 * @return {[type]}            [description]
 */
http.httpRequest = function (httpForm, httpServer, _callback, _errorBack = () => {}) {
    httpServer(httpForm).then((res) => {
        if (res.code == 114) {
            localStorage.removeItem('token');
            window.location.href = Ip;
            Message.error('登录过期');
        } else {
            _callback(res);
        }
    }, data => {
        _errorBack(data);
        Message.error('请求失败');
    });
};

/**
 * [description 请求拦截]
 * @param  {[type]} config [description]
 * @return {[type]}        [description]
 */
http.interceptors.request.use(config => {
    config.headers['token'] = localStorage.getItem('token'); // 请求头带上token
    return config;
}, error => {
    return Promise.reject(error);
});

/**
 * 响应拦截
 */
http.interceptors.response.use(response => {
    if (response.data && response.data.code == 401) { // 401, token失效
        localStorage.removeItem('token');
        window.location.href = Ip; // 暂时这样写
        Message.error('登录过期');
    }
    return response;
}, error => {
    return Promise.reject(error);
});

/**
 * 请求地址处理
 * @param {*} actionName action方法名称
 */
http.adornUrl = (actionName) => {
    return http.ip + actionName;
};

http.isExport = (url, obj) => {

    url += '?token=' + localStorage.getItem('token');

    for (var item in obj) {
        let val = obj[item];

        val = (val === null ? '' : val);

        let objStrl = '&' + item + '=' + val;

        url += objStrl;
    }
    return url;
};

http.limitPageApi = (li, pa, url) => {
    url += '?limit=' + li + '&page=' + pa;

    return url;
};

export default{
    http
};


// WEBPACK FOOTER //
// ./src/common/js/serve.js